import { __makeTemplateObject } from "tslib";
import styled, { css } from 'styled-components';
export var Container = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  padding: 15px;\n  box-sizing: border-box;\n  ", "\n\n  ", "\n"], ["\n  padding: 15px;\n  box-sizing: border-box;\n  ",
    "\n\n  ",
    "\n"])), function (props) {
    return props.fullDimension && css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      height: 100%;\n    "], ["\n      height: 100%;\n    "])));
}, function (props) {
    return props.spacing === 'thin' && css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      padding: ", ";\n    "], ["\n      padding: ", ";\n    "])), props.layout === 'horizontal' ? '10px 15px;' : '15px 10px');
});
var templateObject_1, templateObject_2, templateObject_3;
